import { exists } from '@engine/lib/utility/exists';

function addCountriesOptionsToDropdown(selector, options, selected) {
  $.each(options, function (key, value) {
    var option = $('<option/>').attr('value', value).text(key);

    if (value === selected) {
      option.attr('selected', 'selected');
    }

    $(selector).append(option);
  });
}

function addSupportedCountries(transactionType, paymentType) {
  $.ajax({
    url: '/virtual_terminal/supported_countries/' + transactionType,
    data: {
      payment_type: paymentType
    }
  }).done(function (data) {
    var selectedCountry = $('#billing_address_country option:selected').val();
    $('#billing_address_country').empty();
    addCountriesOptionsToDropdown('#billing_address_country', data, selectedCountry);
    $('.for_chosen').trigger('chosen:updated');
    var selectedCountryShipping = $('#shipping_address_country option:selected').val();
    $('#shipping_address_country').empty();
    addCountriesOptionsToDropdown('#shipping_address_country', data, selectedCountryShipping);
    $('.for_chosen').trigger('chosen:updated');
  });
}

function initialCountryLoad(transactionType, paymentType) {
  if (paymentType === '' || typeof paymentType === 'undefined') {
    return;
  }

  addSupportedCountries(transactionType, paymentType);
}

function listenForPaymentTypeChange() {
  if (!exists($('[id^="virtual_terminal_"]'))) {
    return;
  }

  var transactionType = window.location.pathname.split('/').pop();
  var paymentType = $('#virtual_terminal_' + transactionType + '_payment_type').val();
  initialCountryLoad(transactionType, paymentType);
  $('#virtual_terminal_' + transactionType + '_payment_type').on('change', function () {
    var newPaymentType = $(this).val();
    addSupportedCountries(transactionType, newPaymentType);
  });
}

var SupportedCountries = {
  listenForPaymentTypeChange: listenForPaymentTypeChange
};
export default SupportedCountries;